import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Grupo } from '../../models/grupo';
import { Solicitud } from '../../models/solicitud';
import { GrupoService } from '../../services/grupo.service';
import { SolicitudService } from '../../services/solicitud.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [GrupoService, SolicitudService]
})
export class LoginComponent implements OnInit {
  public grupo: Grupo;
  public solicitud: Solicitud;
  public status: string;
  public status_request: string;
  public status_remember_password: any;
  public message_success: string;
  public message_error: string;
  public message_success_request: string;
  public message_success_remember_password: any;
  public message_error_remember_password: any;
  public message_error_request: string;
  public token;
  public identity;
  public form;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _grupoService: GrupoService,
    private _solicitudService: SolicitudService
  ) {
    this.identity = this._grupoService.getIdentity();
    this.token = this._grupoService.getToken();
    this.grupo = new Grupo(1, 1, '', '', '', '', '', '', '', '', 1);
    this.solicitud = new Solicitud(1, 0, '', '', '', '', '', '', '', '', '');
  }

  ngOnInit() {
    if (this.identity) {

      if (this.identity['rol_id'] == '3' && this.identity['estatus'] == 0) {

        this._router.navigate(['cambiar_password']);

      } else if (this.identity['rol_id'] == 3 && this.identity['estatus'] > 0) {

        this._router.navigate(['dashboard']);

      } else if (this.identity['rol_id'] == '1' || this.identity['rol_id'] == '2') {

        this._router.navigate(['panel_de_control']);

      }
    }
    this.logout();
  }

  rememberPassword() {
    var email = $("#email_remember").val();
    let data = { email }
    $(".loading").show();

    this._grupoService.remember_password(data).subscribe(
      response => {
        $(".loading").hide();
        $(".remember").show();
        this.status_remember_password = 'success';
        this.message_success_remember_password = response.message
      },
      error => {
        $(".loading").hide();
        $(".remember").show();

        this.status_remember_password = 'error';
        this.message_error_remember_password = error.error.message

        setTimeout(function () {
          $(".remember").fadeTo(500, 1).slideUp(500, function () {
            $(".remember").hide();
          });
        }, 3000);
      }
    )
  }

  login(form) {
    this._grupoService.signup(this.grupo).subscribe(
      response => {
        // Obtener el token 
        if (response.status != 'error') {
          $(".alert").show();

          this.status = 'success';
          this.message_success = 'Usuario identificado correctamente: ';

          setTimeout(function () {
            $(".alert").fadeTo(500, 1).slideUp(500, function () {
              $(".alert").hide();
            });
          }, 3000);

          this.token = response;
          localStorage.setItem('token', this.token);

          // Obtener al usuario identificado
          this._grupoService.signup(this.grupo, true).subscribe(

            response => {

              this.identity = response;
              // Redirección

              localStorage.setItem('identity', JSON.stringify(this.identity));

              if (this.identity['rol_id'] == 3 && this.identity['estatus'] == 0) {

                this._router.navigate(['cambiar_password']);

              } else if (this.identity['rol_id'] == 3 && this.identity['estatus'] > 0) {

                this._router.navigate(['dashboard']);

              } else if (this.identity['rol_id'] == 1 || this.identity['rol_id'] == 2) {

                this._router.navigate(['panel_de_control']);

              }
            },
            error => {
              this.message_error = error;
            }
          );

        } else {
          $(".alert").show();

          this.status = 'error';
          this.message_error = response.message;

          setTimeout(function () {
            $(".alert").fadeTo(500, 1).slideUp(500, function () {
              $(".alert").hide();
            });
          }, 3000);

        }
      },
      error => {
        this.message_error = error;
      }
    );
  }

  getImage(image) {
    /*  Indicamos que img almacenara un objeto tarjet del
        comportamiento image
    */
    let img: any = image.target;
    if (img.files.length > 0) {

      this.form = new FormData();
      // indicamos que form contendra el valor de files en la posición 0
      this.form.append('image', img.files[0]);
      // Hacemos uso del servicio y adjuntamos la imagen
    }
  }

  storeRequest(form) {
    $(".create").show();
    if (this.form == null) {
      setTimeout(function () {
        $(".create").fadeTo(500, 1).slideUp(500, function () {
          $(".create").hide();
        });
      }, 3000);
      this.status_request = 'error';
      this.message_error_request = 'Favor de adjuntar la imagen';
    } else if (this.solicitud['nombre'].length == 0 ||
      this.solicitud['email'].length == 0 ||
      this.solicitud['telefono'].length == 0 || this.solicitud['licencia_funcionamiento'].length == 0 ||
      this.solicitud['nombre_establecimiento'].length == 0 || this.solicitud['re_email'].length == 0) {

      setTimeout(function () {
        $(".create").fadeTo(500, 1).slideUp(500, function () {
          $(".create").hide();
        });
      }, 3000);

      this.status_request = 'error';
      this.message_error_request = 'Los campos marcados con un asterisco son necesarios';

    } else {
      let apellidos = (this.solicitud['apellidos'].length == 0) ? null : this.solicitud['apellidos']
      this._solicitudService.create(this.form, this.solicitud['nombre'], apellidos, this.solicitud['email'], this.solicitud['re_email'], this.solicitud['telefono'], this.solicitud['licencia_funcionamiento'], this.solicitud['nombre_establecimiento']).subscribe(
        response => {
          // Obtener el token 
          if (response.status == 'success') {
            form.reset();
            $("#img").val('')
            this.status_request = response.status;
            this.message_success_request = response.message;

            setTimeout(function () {
              $(".create").fadeTo(500, 1).slideUp(500, function () {
                $(".create").hide();
              });
            }, 3000);

          } else {
            setTimeout(function () {
              $(".create").fadeTo(500, 1).slideUp(500, function () {
                $(".create").hide();
              });
            }, 3000);
            this.status_request = 'error';
            this.message_error_request = response.message;
          }
        },
        error => {
          this.message_error = error;
        }
      );
    }
  }

  logout() {
    this._route.params.subscribe(params => {
      // convertir a entero
      let logout = +params['sure'];
      if (logout == 1) {
        localStorage.removeItem('identity');
        localStorage.removeItem('token');
        this.identity = null;
        this.token = null;

        // Redireccionar
        this._router.navigate(['login']);
      }
    });
  }

}
